import classplusLogo from "../../assets/Images/classplus-logo.png";
import rightArrow from "../../assets/Images/arrow-gray.png";
import "./headings.css";
const Headings = ({
  userInputs,
  isNumberSubmitted,
  coachingName,
  showRadarScreen,
}) => {
  return (
    <div className="relative overflow-hidden">
      {/* <img src={classplusLogo} alt="" className="absolute w-32 top-1 left-1" /> */}
      <div className="flex flex-col justify-between w-full mt-8 px-2">
        {isNumberSubmitted && !showRadarScreen ? (
          <>
            <h3 className="text-2xl text-colorHeading font-semibold">
              <span className="border-b-4  border-colorWhite">Hi</span>,{" "}
              {coachingName}
            </h3>
            <p>We have something special in store for you</p>
          </>
        ) : showRadarScreen ? (
          <h3 className="text-2xl text-colorHeading font-semibold">
            These are the top 3{" "}
            {userInputs["youtuber-name"]
              ? "YouTubers in your category"
              : "educators in your region"}
          </h3>
        ) : (
          <>
          <div>
            <h1
              className="not-italic font-bold text-2xl"
              style={{color:"#009ae0"}}
            >
               Become India’s Top Educator With Your Own App!
            </h1>
          </div>

            <div className="flex flex-row justify-between relative w-full lowerContainer">
              <div className="text-white mt-3.5">
                <ul className="leading-7 ml-4">
                  <li style={{listStyleType: "disc"}}>
                      <span className="ml-2 text-base">Grow your teaching business by 10x</span>
                  </li>
                  <li style={{listStyleType: "disc"}}>
                      <span className="ml-2 text-base">
                      Upload & sell your courses
                      </span>
                  </li>
                  <li style={{listStyleType: "disc"}}>
                  <span className="ml-2 text-base">
                  Become a brand of your own
                  </span>
                  </li>
                </ul>
              </div>
            </div>


          </>
        )}
      </div>
    </div>
  );
};

export default Headings;
